<template>
    <span v-if="!isCarrierIconConfigured"></span>
    <font-awesome-icon v-else-if="icon.startsWith('fas ')" :icon="icon" class="text-primary"/>
    <img v-else :src="`/${icon}`" alt=""/>
</template>

<script>
export default {
    name: "CarrierIcon",

    props: {
        carrier: {required: true, type: String},
    },

    computed: {
        isCarrierIconConfigured() {
            return !!CARRIER_ICONS[this.carrier]
        },
        icon() {
            return CARRIER_ICONS[this.carrier]
        }
    },
}

const CARRIER_ICONS = {
    'postnl_parcel': 'postnl.png',
    'dhl': 'dhl.png',
    'customer': 'fas fa-user',
    'store': 'fas fa-store-alt',
    'vendor': 'fas fa-industry'
}
</script>

<style scoped>

</style>
